import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";
import { Trad } from "../../components/";
import { _SideNavItem } from ".";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import logo from "../images/logo_inar.png";

interface ISideNavProps {
    Open: boolean;
    OnClose: () => void;
}

const useStyles = makeStyles(theme => ({
    header: {
        color: theme.palette.grey[300],
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        background: theme.palette.primary.main
    },
    menu: {
        width: 220
    },
    logo: {
        paddingTop: "5px",
        width: 90,
        height: 50
    }
}));

export const _SideNav: React.FC<ISideNavProps> = ({ Open, OnClose }) => {
    const classes = useStyles();
    const [IsLoading, setIsLoading] = useState(true);
    const [SideMenu, setSideMenu] = useState<Dati.CRisAPIListaMenu | undefined>(undefined);

    const history = useHistory();

    const loadData = () => {
        const mainMenu = Glob.GetMenu();
        const Param: CChiamaWebParametri = {
            URL: `/api/Menu/Azioni?sessione=${Glob.GetSessione().Sessione}&id_MenuMain=${mainMenu.ID_MenuMain}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIListaMenu) => {
                setIsLoading(false);
                setSideMenu(data);
            }
        };

        Glob.Log(Glob.LogCat.Menu, false, "AggiornaMenu Azioni", mainMenu.ID_MenuMain);

        new ChiamaWeb().Chiama(Param);
    };

    useEffect(loadData, [Glob.GetMenu().ID_MenuMain]);

    return (
        <Drawer open={Open} onClose={OnClose}>
            <div className={classes.header}>
                <a href="/">
                    <img alt="Logo" src={logo} className={classes.logo} />
                </a>
                <IconButton aria-label="close drawer" onClick={OnClose} color="inherit">
                    <ChevronLeftIcon />
                </IconButton>
            </div>
            <Divider />
            <List className={classes.menu}>
                {IsLoading ? (
                    <ListItem>
                        <ListItemText>
                            <em>{Trad.Trad("Caricamento...")}</em>
                        </ListItemText>
                    </ListItem>
                ) : (
                    <>
                        {SideMenu?.Dati?.map(item => (
                            <_SideNavItem Data={item} ToggleSideMenu={OnClose} key={item.ID_Menu} />
                        ))}
                        <ListItem
                            button
                            component="a"
                            onClick={() => {
                                OnClose();
                                history.goBack();
                            }}
                        >
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                            <ListItemText primary={Trad.Trad("Indietro")} />
                        </ListItem>
                    </>
                )}
            </List>
        </Drawer>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/SideNav.tsx